import {getDaysDifference} from "./dateHelpers";

const CERTIFICATE_CATEGORY_MAP = {
    slots: "Яхтинг в городе",
    arrivals: "Путешествия",
    groups: "Школа капитанов",
    children: "Детский клуб",
    shop: "Магазин",
    practices: "Практики",
    glamping: "Глэмпинг",
    camps: "Лагеря",
    theory: "Теории",
    lecture: "Лекторий",
    universal: "Универсальный",
};

export const buildAnalyticsCategory = (order) => {
    const base = order?.base;
    const arrival = order?.arrival;
    const group = order?.groupId;
    const practice = order?.practice;

    const locationClasses = group?.isOnline ? 'Онлайн' : group?.place

    const getArrivalDuration = () => {
        return getDaysDifference(arrival?.start_date, arrival?.end_date)
    }

    const cases = {
        slots: ['Sport', base?.name, base?.city, order?.boatClass, order?.duration],

        travel_russia: ['Travel', 'Приключения По России', arrival?.city, arrival?.country, getArrivalDuration()],

        travel_world: ['Travel', 'Приключения По всему миру', arrival?.city, arrival?.country, getArrivalDuration()],

        camp_russia: ['Travel', 'Лагеря По России', arrival?.city, arrival?.country, getArrivalDuration()],

        camp_world: ['Travel', 'Лагеря По всему миру', arrival?.city, arrival?.country, getArrivalDuration()],

        charter: ['Charter', 'Чартер По всему миру', arrival?.city, arrival?.country, getArrivalDuration()],

        theory: ['School', 'Теория', locationClasses, order?.group_category, group?.isIntensive ? 'интенсив' : 'обычный'],

        practice_russia: ['School', 'Практика РФ', practice?.city, practice?.country, getDaysDifference(practice?.startDate, practice?.endDate)],

        practice_world: ['School', 'Практика Мир', practice?.city, practice?.country, getDaysDifference(practice?.startDate, practice?.endDate)],

        lecture: ['School', 'Лекторий', group?.place],

        certificate: [
            'Certificate',
            CERTIFICATE_CATEGORY_MAP[order?.certificate_category] || order?.certificate_category,
            'По умолчанию',
        ],

        abonement: ['Abonement', order?.abonement_name]
    }

    const list = cases[order?.product_type] || [];
    return list.filter(Boolean).join(" / ") || "";
}